import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CalculatorsRoutingModule } from './calculators-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, CalculatorsRoutingModule]
})
export class CalculatorsModule {}
